/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { Box, Fab, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { getDoc, updateDoc, doc, collection, DocumentSnapshot, getDocs, QuerySnapshot } from "firebase/firestore"
import { db } from "../../firebase"
import { ControlledJsonEditor as JsonEditor } from './lib/JSONEditor'
import 'jsoneditor-react/es/editor.min.css'
import { toast } from 'react-toastify'

const FormConfig = () => {
  const [formJson, setFormJson] = useState<string>('')
  const [selectedForm, setSelectedForm] = useState<string>('individual')
  const [selectItems, setSelectItems] = useState<Array<any>>([])
  const [isEdited, setIsEdited] = useState<boolean>(false)

  useEffect(() => {
    getDocs(collection(db, 'forms')).then((_: QuerySnapshot) => {
      const options = _.docs.map((doc) => <MenuItem value={doc.id}>{doc.id}</MenuItem>)
      setSelectItems(options)
    })
  }, [])

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), selectedForm)).then((_: DocumentSnapshot) => {
      _.exists() && setFormJson(_.data().conf)
      setIsEdited(false)
    })
  }, [selectedForm])

  const onChangeSelect = (event: SelectChangeEvent) => {
    if (isEdited && !window.confirm("編集したデータを消去してよろしいですか？")) {
      return
    }
    setSelectedForm(event.target.value)
  }

  const onChange = (newValue: any) => {
    setIsEdited(true)
    setFormJson(newValue)
  }

  const save = () => {
    updateDoc(doc(collection(db, 'forms'), selectedForm), { conf: formJson }).then(() => {
      setIsEdited(false)
      toast.success("保存しました")
    }).catch(e => {
      toast.error(e)
    })
  }

  const download = async () => {
    const blobData = new Blob([JSON.stringify(formJson)], {
      type: 'text/json',
    })
    const data = URL.createObjectURL(blobData)
    const elem = document.createElement("a")
    elem.href = data
    elem.download = `${selectedForm}.json`
    document.body.appendChild(elem)
    elem.click()
    await setTimeout(() => {}, 100)
    URL.revokeObjectURL(data)
    document.body.removeChild(elem)
    return true
  }

  const upload = async () => {
    const input = document.createElement("input")
    input.type = "file"
    input.onchange = ((e: any) => {
      if (!e.target.files || e.target.files.length === 0) {
        alert("ファイルを選択してください")
      }
      const [file] = e.target.files
      const reader = new FileReader()
      reader.onload = event => {
        let jsonData = ""
        const content = event.target?.result
        try {
          jsonData = JSON.parse(content as string)
        } catch (error) {
          console.error(error)
          toast.error("JSONファイルを解析できませんでした。")
          return
        }
        if(!confirm("データを反映しますか？")) return
        updateDoc(doc(collection(db, 'forms'), selectedForm), { conf: jsonData }).then(() => {
          toast.success("データを反映しました")
        }).catch(e => {
          toast.error(e)
        })
      }
      reader.readAsText(file)
    })
    input.click()
  }

  return formJson ? (
    <Box>
      <Box m={1}>
        <Select
          value={selectedForm}
          onChange={onChangeSelect}
          style={{ width: 200 }}
        >
          {selectItems}
        </Select>
      </Box>
      <Box>
        <JsonEditor
          value={formJson}
          onChange={onChange}
        />
      </Box>
      <Box display="flex" m={1} justifyContent="end">
        <Fab variant="extended" color="warning" size="large" onClick={download} style={{ right: 20, bottom: 140, position: "fixed" }}>ダウンロード</Fab>
        <Fab variant="extended" color="success" size="large" onClick={upload} style={{ right: 20, bottom: 80, position: "fixed" }}>アップロード</Fab>
        <Fab variant="extended" color="info" size="large" onClick={save} style={{ right: 20, bottom: 20, position: "fixed" }}>保&emsp;存</Fab>
      </Box>
    </Box>

  ) : <div/>
}

export default FormConfig
